import { IModal, ModalContext, ModalTypeMap } from './Modal'
import { ModalRegistry } from './ModalRegistry'

export class ModalManager {
    private modalsMap: Map<string, IModal<unknown>> = new Map()
    private modalRegistry: ModalRegistry
    constructor(private modalContext: ModalContext) {
        this.modalRegistry = ModalRegistry.getInstance()
    }

    useModals(ids: string[]) {
        ids.forEach(id => {
            const modalClass = this.modalRegistry.getModal(id)
            if (modalClass) {
                const modal = new modalClass(this.modalContext)
                this.modalsMap.set(id, modal)
            } else {
                console.error(`Modal with id ${id} not found`)
            }
        })
    }

    getModal<K extends keyof ModalTypeMap>(id: K): IModal<ModalTypeMap[K]> | undefined
    getModal(id: string): IModal<unknown> | undefined {
        return this.modalsMap.get(id)
    }

    setModalMetaData<K extends keyof ModalTypeMap>(id: K, metaData: ModalTypeMap[K]): void
    setModalMetaData(id: string, metaData: unknown): void {
        const modal = this.modalsMap.get(id)
        if (modal) {
            modal.setMetaData(metaData)
        } else {
            console.error(`Modal with id ${id} not found`)
        }
    }

    updateModalMetaData<K extends keyof ModalTypeMap>(
        id: K,
        partialMetaData: Partial<ModalTypeMap[K]>
    ): void
    updateModalMetaData(
        id: string,
        partialMetaData: Partial<ModalTypeMap[keyof ModalTypeMap]>
    ): void {
        const modal = this.modalsMap.get(id)
        if (modal) {
            modal.updateMetaData(partialMetaData)
        } else {
            console.error(`Modal with id ${id} not found`)
        }
    }

    getModalMetaData<K extends keyof ModalTypeMap>(id: K): ModalTypeMap[K] | undefined
    getModalMetaData(id: string): unknown | undefined {
        const modal = this.modalsMap.get(id)
        return modal?.metaData
    }

    showModal<K extends keyof ModalTypeMap>(id: K): void
    showModal(id: string): void {
        const modal = this.modalsMap.get(id)
        if (modal) {
            modal.setVisibility(true)
        } else {
            console.error(`Modal with id ${id} not found`)
        }
    }

    hideModal<K extends keyof ModalTypeMap>(id: K): void
    hideModal(id: string): void {
        const modal = this.modalsMap.get(id)
        if (modal) {
            modal.setVisibility(false)
        } else {
            console.error(`Modal with id ${id} not found`)
        }
    }
}
